import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
// import axios from "axios";

const app = createApp(App);

// app.config.globalProperties.$domainurl = "https://k-buda.shop:3215";
app.use(store).use(router).mount("#app");
